import { GridRow } from 'ui/indexPages/tables/grid';
import { Skeleton } from 'ui/skeleton';
import { DEFAULT_NUMBER_OF_GOALS_SKELETON_ROWS, GOALS_GRIDS } from '../../constants';

type GoalsSkeletonRowsProps = {
  numRows?: number | null;
};

export const GoalsSkeletonRows = ({
  numRows = DEFAULT_NUMBER_OF_GOALS_SKELETON_ROWS,
}: GoalsSkeletonRowsProps) => (
  <>
    {Array(numRows)
      .fill(null)
      .map((_, i) => (
        <GridRow gridLayout={GOALS_GRIDS} data-test="skeleton-row" key={i}>
          {Array(2)
            .fill(null)
            .map((_, index) => (
              <div key={index}>
                <Skeleton data-test="goal-skeleton-cell" />
              </div>
            ))}
        </GridRow>
      ))}
  </>
);
